import {CanMatchFn} from '@angular/router';

export type ConnectWorkflowCanvasVisualFixtureState = 'succeeded' | 'failed' | 'empty' | 'error';

const allowedFixtureStates = new Set<ConnectWorkflowCanvasVisualFixtureState>(['succeeded', 'failed', 'empty', 'error']);
const fixtureRoutePattern = /^\/connect\/workflows\/review-fixture\/[^/]+\/run\/[^/]+$/;
const localhostOrigins = ['localhost', '127.0.0.1', '[::1]', '::1'];

export function readConnectWorkflowCanvasVisualFixture(href: string): {state: ConnectWorkflowCanvasVisualFixtureState} | null {
  const url = new URL(href, typeof window !== 'undefined' && window.location ? window.location.origin : 'http://localhost');
  const isLocalHost = localhostOrigins.includes(url.hostname);
  const fixtureState = url.searchParams.get('connectWorkflowVisualFixture') || '';

  if (!isLocalHost || !fixtureRoutePattern.test(url.pathname) || !allowedFixtureStates.has(fixtureState as ConnectWorkflowCanvasVisualFixtureState)) {
    return null;
  }

  return {
    state: fixtureState as ConnectWorkflowCanvasVisualFixtureState,
  };
}

export function isConnectWorkflowCanvasVisualFixtureUrl(href: string): boolean {
  return readConnectWorkflowCanvasVisualFixture(href) !== null;
}

export const connectWorkflowCanvasVisualFixtureCanMatch: CanMatchFn = () => {
  if (typeof window === 'undefined' || !window.location) {
    return false;
  }

  return isConnectWorkflowCanvasVisualFixtureUrl(window.location.href);
};
